export default __webpack_public_path__ + "static/media/japon-text2.d7f73f1c.png";